import React, { useContext, useState, useEffect } from "react";

import News_IMG1 from "../images/bblog.jpg";
import News_IMG2 from "../images/blog2.jpg";
import AOS from "aos";
import { AuthContext } from "../../utility/services/AuthContext";
import Functions from "../../utility/services/Functions";
import ApiService from "../../utility/services/ApiService";
import { Image } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import ConstConfig from "../../utility/configs/constConfig";
import { trackScreenView, getUserTrackingParams } from "../../utility/services/analyticsService";

const BlogPost = () => {
  const { news_id } = useParams();

  // LOGICAL VARIABLES
  React.useEffect(() => {
    trackScreenView("blog_post_screen", { screen_name: "Blog Post", ...getUserTrackingParams(user) });
    AOS.init({
      // ... your other initialisation options here ...
      once: true,
    });
  }, []);

  const [newsDetails, setNewsDetails] = useState({});
  const [initialLoading, setInitialLoading] = useState(false);

  const { setLoading, user } = useContext(AuthContext);
  const { consoleService, formet_date } = Functions();
  const { get_specific_news_deatils } = ApiService();

  useEffect(() => {
    get_initial_details();
  }, []);

  async function get_initial_details() {
    try {
      setLoading(true);
      const res = await get_specific_news_deatils({ news_id });
      if (res.status === 1) {
        setNewsDetails(res.data);
        setInitialLoading(true);
        setLoading(false);
      } else {
        consoleService("error in get_initial_details fun =- ", res.message);
      }
    } catch (err) {
      consoleService("error in get_initial_details fun = ", err);
    }
  }

  return (
    <section className="blogPost">
      {initialLoading && (
        <div key={0}>
          <div className="container mb-2">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <Link to={"/news"} className="returnnews">
                  Return to News
                </Link>
                <div className="news_box">
                  <p className="mb-0">{newsDetails.title}</p>
                  <div className="news_Flex">
                    <span className="badge">{newsDetails.category_title}</span>
                    <span className="time">
                      {formet_date(newsDetails.created_at)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Image
            src={`${ConstConfig.IMAGE_URL}/${newsDetails.thumbnail_img}`}
            alt=""
            className="bImg"
          />
          <div className="container mb-2 rowsp rowsp1">
            <div className="row justify-content-center">
              <div
                className="col-md-12"
                dangerouslySetInnerHTML={{ __html: newsDetails.des }}
              ></div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default BlogPost;
